import { put, select, takeLatest } from 'redux-saga/effects'
import { ISigner, ISignerData } from '../store/completeChart.types'
import { getSignerSelector, getSignerListSelector } from '../selectors'
import { setSignerList } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* deleteSigner() {
  const signerData: ISignerData = yield select(getSignerListSelector)
  const signer: ISigner = yield select(getSignerSelector)
  if (signer && signerData) {
    yield put(setSignerList(signerData?.filter((s) => signer.key !== s?.key)))
  }
}
export function* deleteSignerSaga() {
  yield takeLatest([CompleteChartConstants.DELETE_SIGNER], performWithMutexHOG, deleteSigner)
}
